import { CookieService } from 'ngx-cookie-service';

export class CustomCookieService extends CookieService {
  private skipInvalidValues: string[] = [
    'customerEmail',
    'customerName',
    'customerPhoneNumber'
  ];

  set(name: string, value: string, ...args: any[]): void {
    if (this.skipInvalidValues.includes(name) && (!value || value == 'null')) {
      console.log(`Skipping set cookie. Invalid value: ${name}=${value}`);
    } else {
      super.set(name, value, ...args);
    }
  }
}